<template>
  <div class="main-layout">
    <div class="layout-content">
      <u-table
        :headers="headers"
        :items="items"
        :mobileBreakpoint="900"
        :showSelect="false"
        itemKey="user_id"
        v-model="userSelected"
        :pagination="pagination"
        @onChangePagination="onChangePagination"
        :loading="loading"
      >
        <!-- // # Header Table -->
        <template v-slot:header>
          <v-row justify="space-between" align="center">
            <!-- // # Action Group -->
            <v-col cols="12" md="2">
              <v-btn color="primary" block dark @click="dialog = !dialog">
                <v-icon>mdi-plus</v-icon>เพิ่ม{{ NameComponent }}
              </v-btn>
            </v-col>

            <!-- // # Search Group -->
            <v-col cols="12" md="4">
              <v-row justify="center" align="center">
                <v-col>
                  <v-text-field
                    v-model="keyword"
                    name="name"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    placeholder="ค้นหา"
                    label="ค้นหา"
                    id="id"
                    hide-details
                    @keyup.enter="init()"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-btn color="primary" block dark @click="init()">
                    ค้นหา
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
          {{
            pagination.row * pagination.page -
            pagination.row +
            (items.indexOf(item) + 1)
          }}
        </template>

        <!-- // TODO Name -->
        <template v-slot:[`item.name`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.name }}
          </span>
        </template>

        <!-- // TODO Descriotion -->
        <template v-slot:[`item.description`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.description }}
          </span>
        </template>

        <!-- // TODO Name -->
        <template v-slot:[`item.create_date`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.create_date | BE_DD_MM_YYYY_HH_MM }}
          </span>
        </template>

        <!-- // TODO Name -->
        <template v-slot:[`item.apikey`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="writeClipboard(item.apikey)"
                v-on="on"
                v-bind="attrs"
              >
                <v-icon small color="success">mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>คัดลอก API Key</span>
          </v-tooltip>
        </template>

        <!-- // TODO Action  -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>แก้ไขข้อมูล</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                :dark="item.user_id === userInfo.user_id ? false : true"
                color="error"
                @click="deleteItem(item)"
                :disabled="item.user_id === userInfo.user_id ? true : false"
              >
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>
      </u-table>
    </div>

    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
        <v-row no-gutters>
          <v-col cols="12">
            <u-text-field
              required
              :rules="[Rule.noInPut, Rule.noSpace]"
              title="ชื่อ"
              v-model="editedItem.name"
            >
            </u-text-field>
          </v-col>
          <v-col cols="12">
            <u-text-field title="Allow Host" v-model="editedItem.allows">
            </u-text-field>
          </v-col>
          <v-col>
            <u-text-area title="รายละเอียด" v-model="editedItem.description">
            </u-text-area>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions="{ valid }">
        <v-row>
          <v-col>
            <v-btn
              @click="save"
              :disabled="!valid"
              block
              color="primary"
              :loading="loadingSave"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col>
            <v-btn block color="error" @click="close">ยกเลิก</v-btn>
          </v-col>
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>

<script>
export default {
  props: {
    hospital_id: {
      type: String
    },
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      verify: '',
      users: [],
      permissions: [],
      permissionsEdit: [],
      userSelected: [], // สำหรับ User ที่ถูก Select ในตราง User
      NameComponent: ' API Key',
      dialog: false, // สำหรับใช้เปิดปิด dialog add/edit
      editedIndex: -1,
      editedItem: {
        apikey_id: '',
        name: '',
        description: '',
        create_date: '',
        create_by: '',
        allows: ''
      },
      defaultItem: {
        apikey_id: '',
        name: '',
        description: '',
        create_date: '',
        create_by: '',
        allows: ''
      },
      keyword: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number',
          width: '80px'
        },
        {
          text: 'ชื่อ',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'รายละเอียด', value: 'description', sortable: false },
        {
          text: 'วันที่',
          value: 'create_date',
          sortable: false,
          align: 'center',
          width: '200px'
        },
        {
          text: 'API key',
          value: 'apikey',
          sortable: false,
          align: 'center',
          width: '80px'
        },
        {
          text: 'จัดการ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '120px'
        }
      ],
      items: [],
      loading: false,
      loadingSave: false,
      pagination: {
        total: 0,
        page: 1,
        row: 10
      }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? `เพิ่ม${this.NameComponent}`
        : `แก้ไข${this.NameComponent}`
    },
    formSubTitle () {
      return this.editedIndex === -1
        ? `กรอกข้อมูลเพื่อสร้าง${this.NameComponent}`
        : `กรอกข้อมูลเพื่อแก้ไข${this.NameComponent}`
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination.page,
        row: this.pagination.row,
        keyword: this.keyword
      }
      const res = await this.getHostitalApiKeyTable(this.hospital_id, payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },

    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },

    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.$swal({
        allowEnterKey: false,
        title: `ลบ${this.NameComponent}`,
        text: `คุณต้องการลบ${this.NameComponent}นี้ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.antmessage.loading('กำลังดำเนินการ', 0)
          const payload = {
            hospital_id: this.hospital_id,
            apikey_id: item.apikey_id
          }
          const res = await this.deleteHostitalApiKey(payload)
          this.antmessage.destroy()
          if (res.status) {
            this.init()
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: `ลบ${this.NameComponent}สำเร็จ`,
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    },

    save () {
      if (this.editedIndex > -1) {
        // TODO Update Data
        this.$swal({
          allowEnterKey: false,
          title: `แก้ไข${this.NameComponent}`,
          text: `คุณต้องการแก้ไข${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              name: this.editedItem.name,
              description: this.editedItem.description,
              allows: this.editedItem.allows
            }
            const res = await this.updateHostitalApiKey(
              this.hospital_id,
              this.editedItem.apikey_id,
              payload
            )
            this.loadingSave = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `แก้ไข${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      } else {
        // TODO Create Data
        this.$swal({
          allowEnterKey: false,
          title: `เพิ่ม${this.NameComponent}`,
          text: `คุณต้องการเพิ่ม${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              name: this.editedItem.name,
              description: this.editedItem.description,
              allows: this.editedItem.allows
            }
            const res = await this.createHostitalApiKey(
              this.hospital_id,
              payload
            )
            this.loadingSave = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `เพิ่ม${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      }
    },

    close () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async writeClipboard (val) {
      // TODO เป็นส่วนที่ใช้ในการ ADD text ใส่ Clipboard
      await navigator.clipboard.writeText(val)
      this.antmessage.success('คัดลอกสำเร็จ')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  height: 100%;
}
.layout-content {
  height: 100%;
  padding: 0;
  margin: 0;
}
.header-custom-table .header-custom-search {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}
.header-custom-table .header-custom-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  height: 100%;
  min-height: 70px;
}
</style>
